module.exports = __webpack_public_path__ + "static/media/conhecimento.e29008de.svg";